import { useId } from "react";

// The Ontik AI mark: a large + small sparkle filled with the brand gradient
// (pink → purple → blue → orange). Used standalone and inside the suggestion
// card's hollow tile. useId keeps the gradient unique per instance.
const SPARKLE =
  "M12 0C12.4 6.3 17.7 11.6 24 12C17.7 12.4 12.4 17.7 12 24C11.6 17.7 6.3 12.4 0 12C6.3 11.6 11.6 6.3 12 0Z";

export default function AiSparkleIcon({ className = "size-5" }) {
  const id = useId().replace(/:/g, "");
  return (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" className={className}>
      <defs>
        <linearGradient
          id={id}
          x1="0"
          y1="24"
          x2="24"
          y2="0"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0%" stopColor="#ec4899" />
          <stop offset="35%" stopColor="#a855f7" />
          <stop offset="70%" stopColor="#3b82f6" />
          <stop offset="100%" stopColor="#fb923c" />
        </linearGradient>
      </defs>
      <path d={SPARKLE} fill={`url(#${id})`} transform="translate(2.2 5.3) scale(0.66)" />
      <path d={SPARKLE} fill={`url(#${id})`} transform="translate(14.6 2.8) scale(0.3)" />
    </svg>
  );
}
